import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Image,
  Link,
  Box,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_purchase_order_list } from "../../redux/purchaseOrderSlice";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const PurchasOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [rows, setRows] = useState(location.state?.rows || 10);
  const [page, setpage] = useState(location.state?.page || 1);
  const [initialValue, setInitialValue] = useState(location.state?.initialValue || 1);
  const { purchase_order_list, total_quotation_count,loading } = useSelector(
    (state) => state.purchaseOrder
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // 🔹 Added search state

  useEffect(() => {
    store.dispatch(get_purchase_order_list({ page, rows }));
  }, [page, rows]);

  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_purchase_order_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_quotation_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_quotation_count || setpage(page + 1);
    rows * page >= total_quotation_count ||
      store.dispatch(get_purchase_order_list({ page: page + 1, rows: rows }));
  };

  // 🔹 Handle view/download click
  const handleViewFile = (url) => {
    if (!url) return;

    const fileExtension = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
      setSelectedImage(url);
      onOpen(); // show image modal
    } else if (fileExtension === "pdf") {
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // 🔹 Filter data based on search (name or PO number)
  const filteredOrders = purchase_order_list?.filter(
    (el) =>
      el.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      el.ponum?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        display="flex"
        flexDirection={["column", "column", "row"]}
        alignItems={["stretch", "stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize="xl" flexShrink={0}>
          Purchase Order List
        </Heading>

        <Spacer display={["none", "none", "block"]} />

        <Flex
          direction={["column", "row"]}
          gap={2}
          alignItems="center"
          justifyContent={["flex-start", "flex-end"]}
          flex="1"
          flexWrap="wrap"
        >
          <Select
            placeholder="Rows"
            size="md"
            w={["100%", "100px"]}
            value={rows}
            onChange={(e) => {
              store.dispatch(get_purchase_order_list({ page, rows: e.target.value }));
              setRows(e.target.value);
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>

          {/* 🔹 Search Input */}
          <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "auto"]} maxW="sm">
            <Input
              placeholder="Search by Vendor or PO No..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
        </Flex>
      </Card>

{loading ? (<GasCylinderLoader size="sm" loadingText="Loading Purchase Orders"/>):(<>
  <SimpleGrid minChildWidth="xs" spacing="10px">
        {filteredOrders?.length > 0 ? (
          filteredOrders.map((el) => (
            <Card
              key={el.id}
              paddingInline={5}
              paddingBlock={2}
              cursor="pointer"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              _hover={{ boxShadow: "md", transform: "translateY(-3px)" }}
              transition="all 0.2s ease"
              onClick={() =>
                navigate("/purchase-order/purchaseorder-detail", {
                  state: {
                    id: el.id,
                    page,
                    rows,
                    initialValue,
                  },
                })
              }
            >
              {/* Header */}
              <DisplayData
                fs="16px"
                v_color="#169e49"
                fw="bold"
                value={el.customer_name || "NA"}
              />

              {/* Details */}
              <Box mt={1}>
                {[
                  { title: "PO. No.", value: el.ponum },
                  { title: "Quotation No.", value: el.quotation_no },
                  { title: "PO Date", value: el.createdat },
                  { title: "Quotation Date", value: el.quotation_date },
                  { title: "Date & Time", value: el.podate },
                  {
                    title: "Total Amount",
                    value:
                      el.products && el.products.length > 0
                        ? `₹${el.products
                            .reduce(
                              (total, product) =>
                                total +
                                parseFloat(product.qty || 0) *
                                  parseFloat(product.price || 0),
                              0
                            )
                            .toFixed(2)}`
                        : "NA",
                  },
                  {
                    title: "PO Invoice",
                    value: el.pourl ? (
                      <Link
                        color="blue.500"
                        textDecoration="underline"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewFile(el.pourl);
                        }}
                      >
                        View Image / PDF
                      </Link>
                    ) : (
                      "NA"
                    ),
                  },
                ].map((item, idx) => (
                  <Flex
                    key={idx}
                    justify="space-between"
                    align="center"
                    mb="1"
                    wrap="nowrap"
                  >
                    <Text fontSize="sm" color="gray.600" flex="1" noOfLines={1}>
                      {item.title}
                    </Text>
                    <Text
                      fontSize="sm"
                      color="gray.800"
                      flex="1"
                      textAlign="right"
                      noOfLines={1}
                      fontWeight={
                        item.title === "Total Amount" ? "semibold" : "normal"
                      }
                    >
                      {item.value || "NA"}
                    </Text>
                  </Flex>
                ))}
              </Box>
            </Card>
          ))
        ) : (
          <Text textAlign="center" py={5}>
            No matching records found.
          </Text>
        )}
      </SimpleGrid>

      {/* Pagination */}
      <Card alignItems={"center"} alignSelf={"end"} gap={3} flexDirection={"row"}>
        <FiChevronLeft
          cursor={"pointer"}
          color={page == 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />

        <Flex gap={3}>
          <Text>{initialValue}</Text>-
          <Text>
            {rows * page >= total_quotation_count
              ? total_quotation_count
              : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_quotation_count}</Text>
        </Flex>

        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_quotation_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>

      {/* Image Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Purchase Order Invoice</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedImage && (
              <Image
                src={selectedImage}
                alt="Purchase Order"
                borderRadius="md"
                w="100%"
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
</>)}
     
    </>
  );
};


export default PurchasOrder;
